import remarketing from "../components/remarketing/remarketing";

import { dynamicRemarketing } from '../shared/helpers/gtm_tracking';
import UserTiming from "../shared/helpers/user-timing";

const userTiming = new UserTiming({ src: "remarketing" });

function offerDetail(slug) {
  if (['the-masters', 'the-masters-experience'].indexOf(slug) > -1) {
    dynamicRemarketing({
      hrental_id: slug,
      hrental_pagetype: 'offerdetail'
    });
  }
}

function remarket() {
  userTiming.start("remarket");

  offerDetail(window.location.pathname.split('/')[1]);
  remarketing.facebookPixel();

  userTiming.finish("remarket");
}

window.addEventListener("DOMContentLoaded", remarket);

userTiming.finish();



// WEBPACK FOOTER //
// ./entry_points/remarketing.js